import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import PaneHeader from '../../tools/panes/PaneHeader'

const RenameTooltip = ({
  title,
  label,
  initialValue = '',
  onSubmit,
  onClose,
  t
}) => {
  const [value, setValue] = useState(initialValue)
  const [error, setError] = useState(null)

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    const trimmed = (value || '').trim()
    if (!trimmed) {
      setError(t('GLOBAL.NAME_REQUIRED', { defaultValue: 'Name is required' }))
      return
    }
    onSubmit(trimmed)
  }

  return (
    <div
      className='click-tooltip rename-tooltip'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <PaneHeader
        title={title}
        onClose={(e) => {
          if (e && e.stopPropagation) e.stopPropagation()
          onClose()
        }}
      />

      <form onSubmit={handleSubmit}>
        <div className='tooltip-field'>
          <label className='tooltip-label'>{label}</label>
          <input
            type='text'
            className='tooltip-input rename-input'
            value={value}
            onChange={(e) => {
              setValue(e.target.value)
              if (error) setError(null)
            }}
            autoFocus
          />
          {error && <span className='tooltip-error'>{error}</span>}
        </div>

        <div className='tooltip-actions'>
          <button
            type='button'
            className='btn-cancel'
            onClick={(e) => {
              e.stopPropagation()
              onClose()
            }}
          >
            {t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}
          </button>
          <button
            type='submit'
            className='btn-submit'
            disabled={!value || !value.trim()}
          >
            {t('GLOBAL.RENAME', { defaultValue: 'Rename' })}
          </button>
        </div>
      </form>
    </div>
  )
}

export default withTranslation()(RenameTooltip)
